module.exports = __webpack_public_path__ + "static/media/introduction_2.21630c92.webp";